import { type Command } from '@telespot/core';

/**
 * @group Organizations
 * @category Payloads
 */
export interface ExportOrganizationAffiliatesDetails {
  organizationId: string;
}

/**
 * @group Organizations
 * @category Tokens
 */
export const EXPORT_ORGANIZATION_AFFILIATES = 'export:organization-affiliates';

/**
 * Requests every affiliation of an organization (with user email/verification)
 * for a members CSV export. Runs server-side with the master key so protected
 * user fields like email are available.
 *
 * @group Organizations
 * @category Commands
 */
export class ExportOrganizationAffiliates
  implements Command<typeof EXPORT_ORGANIZATION_AFFILIATES, ExportOrganizationAffiliatesDetails>
{
  public readonly name = EXPORT_ORGANIZATION_AFFILIATES;
  constructor(public readonly details: Readonly<ExportOrganizationAffiliatesDetails>) {}
}
